export default __webpack_public_path__ + "static/media/components-image.73f9b072.svg";